import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { constants } from '../../constants';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { utility } from '../../utility';
import { RequestHistorySearchCondition } from './RequestHistorySearchCondition';
import { RequestHistorySearchResult } from './RequestHistorySearchResult';

/** MyMine Version2.1 RequestHistory画面新規追加
* RequestHistory Page Component
*/
const RequestHistory = () => {
  const screenId = 'MyM705';
  const apiRequest = useMyMApi(screenId);
  const navigate = useNavigate();
  const [requestList, setRequestList] = useState(null);
  const { screenSettings } = useWebContext(screenId);
  const [searchCondition, setSearchCondition] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { authUser, setAuthUser } = useContext(AuthUserContext);

  const defaultInputCondition = {
    titleOrDetail: null,
    requestDateFrom: null,
    requestDateTo: null,
    requestCategory: null,
    targetProductCategory: null,
    answerStatus: [constants.RequestStatus.InComplete, constants.RequestStatus.Complete, constants.RequestStatus.OutOfScope],
  };

  const [searchInputCondition, setSearchInputCondition] = useState(defaultInputCondition);
  const [searchedInputCondition, setSearchedInputCondition] = useState(defaultInputCondition);

  /** 初期表示時 */
  useEffect(() => {

    // 別タブ繊維の場合、キャッシュしてるユーザ情報が引き継がれないため、再取得
    if (!authUser) {
      // ユーザコンテキスト情報再取得
      apiRequest.requestJson('api/page/auth-user', 'GET', (result) => setAuthUser(result));
    }

    const queryParameters = { ...searchInputCondition };
    queryParameters.PageNumber = pageNumber;
    queryParameters.LimitMaxRowCount = screenSettings.MaxRowCount;

    apiRequest.requestJson(
      `api/request/load-list?${utility.makeEncodeParameter(queryParameters)}`,
      'GET',
      (result) => {
        setRequestList(result.Result);
        setSearchCondition(result.Condition)
        setIsLoading(false);
      },
      () => {
        navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
      });
  }, []);

  useEffect(() => {
    // 初期表示時 又は 検索フラグが立っている場合は処理しない
    if (requestList === null || isSearch === true) return;
    requestSearch();
  }, [pageNumber]);

  useEffect(() => {
    // 検索フラグが立っていない場合は処理しない
    if (isSearch === false) return;
    requestSearch();
  }, [isSearch]);

  /**
  * 検索処理
  */
  const requestSearch = () => {
    setIsLoading(true);
    const callbackRequestListSuccessContext = (result) => {
      // ページ番号が2以上で検索結果が無い場合、前のページで再検索
      if (pageNumber > 1 && result.ItemList.length === 0) {
        setPageNumber(pageNumber - 1);
        return;
      }
      setRequestList(result);
      setIsLoading(false);

      // リストのスクロール位置をTopにする
      const listBody = document.querySelector('.MuiCardContent-root');
      if (listBody)
        listBody.scrollTop = 0;
    }
    const callbackRequestListFaildContext = (result) => {
      // 通信がエラーとなった場合ローディング状態を解除
      setIsLoading(false);
    }
    let condition
    if (isSearch) {
      // 検索の場合、現在のフォームの状態で検索をし検索条件を退避
      condition = searchInputCondition;
      setSearchedInputCondition({ ...searchInputCondition })
    } else {
      // ソート・ページングの場合、過去の検索条件を元に検索する
      condition = searchedInputCondition;
    }
    let queryParameters = { ...condition };

    queryParameters.PageNumber = pageNumber;
    queryParameters.LimitMaxRowCount = screenSettings.MaxRowCount;

    apiRequest.requestJson(`api/request/list-page?${utility.makeEncodeParameter(queryParameters)}`, 'GET', callbackRequestListSuccessContext, callbackRequestListFaildContext);
    setIsSearch(false);
  };

  /** Request更新コールバック処理 */
  const callbackUpdateRequest = () => {
    // 一覧再検索
    requestSearch();
  }

  if (!authUser || !searchCondition) {
    return <MyMProgress />;
  }

  return (
    <Box style={{ width: '100%', height: '90%' }}>
      {isLoading && < MyMProgress />}
      <RequestHistorySearchCondition
        screenId={screenId}
        searchCondition={searchCondition}
        searchInputCondition={searchInputCondition}
        setSearchInputCondition={setSearchInputCondition}
        setPageNumber={setPageNumber}
        setIsSearch={setIsSearch}
        setIsLoading={setIsLoading}
        defaultInputCondition={defaultInputCondition}
      />
      <RequestHistorySearchResult
        screenId={screenId}
        requestList={requestList}
        pageNumber={pageNumber}
        setPageNumber={setPageNumber}
        searchCondition={searchCondition}
        callbackUpdateRequest={callbackUpdateRequest}
      />
    </Box>
  );
};

export default RequestHistory;
